
export default  [
   
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'number',
        field: 'page',
        label: 'Página',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_emp',
        label: 'Empresa',
        option: {
            label: 'empresa',
            value: 'id'
        },
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_fun',
        label: 'Trabalhador',
        option: {
            label: 'funcionario',
            value: 'id'
        },
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_con',
        label: 'Consulta',
        option: {
            label: 'consulta',
            value: 'id_con'
        },
        rules: ['required']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/consulta/liberacao/_form/upload-pagina-editar.js